<template>
    <div class="swiper">
        <!-- Swiper -->
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="image in images" :key="image.id">
                    <div class="swiper-slide__image" :style="{'background-image': `url(${ image.url_square })`}" @click="viewFullImage(image)"></div>
                </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>

            <v-dialog
                    v-model="dialogFullImage"
                    width="500"
                    fullscreen

            >
                <v-card>
                    <v-toolbar dark color="primary" flat dense>
                        <v-btn icon dark @click="dialogFullImage = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Full Image View</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout row justify-center align-center fill-height :style="{height:'100vh'}" class="pa-2">
                        <v-flex>
                            <img :src="imageSelected.url_original" alt="" :style="{display:'block', width:'100%', height:'100%', objectFit: 'cover'}">
                        </v-flex>

                    </v-layout>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
    import Swiper from "swiper";
    export default {
        props: {
            images : null
        },
        data() {
            return {
                dialogFullImage : false,
                imageSelected : {url_original: ''},
            }
        },
        methods:{
            viewFullImage(image){
                this.imageSelected = image;
                this.dialogFullImage = true;
            }
        },
        mounted() {
            let swiper = new Swiper('.swiper-container', {
                pagination: {
                    el: '.swiper-pagination',
                },
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
            });
        }
    }
</script>

<style lang="scss">
@import "../scss/app";

    .swiper {
        position: relative;
        height: 100%;

        .swiper-container {
            width: 100%;
            height: 100%;
            position: relative;

            .swiper-slide {
                background-color: #fff;
                padding: 2rem 0;

                .swiper-slide__image
                {
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                    height: 250px;
                }
            }
        }

        .swiper-pagination {

        }

        .swiper-pagination-bullet-active {
            transition-duration: .2s;
            transition-property: background;
        }

        .swiper-pagination-bullet-active {
            background: $secondary-theme-color;
        }
    }
</style>
